import React, { useState } from 'react';
import styles from './index.module.css';

// Modal shown after an owner shares a video/album. Displays the public share
// URL with a copy button and a "Stop sharing" (revoke) action.
export const ShareItemModal = ({
  isVisible,
  url,
  loading,
  revoking,
  onRevoke,
  onClose,
}) => {
  const [copied, setCopied] = useState(false);

  if (!isVisible) return null;

  const handleCopy = async () => {
    if (!url) return;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = url;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    } catch (error) {
      console.error('Copy link failed:', error);
    }
  };

  return (
    <div
      className={styles.overlay}
      role="button"
      tabIndex={0}
      onClick={onClose}
      onKeyDown={() => {}}
    >
      <div
        className={styles.modal}
        role="button"
        tabIndex={0}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={() => {}}
      >
        <button
          type="button"
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>

        <div className={styles.iconCircle}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h2 className={styles.title}>Share link ready</h2>
        <p className={styles.subtitle}>
          Anyone with this link can view this content — no login required.
        </p>

        {loading ? (
          <div className={styles.loadingRow}>Preparing link…</div>
        ) : (
          <>
            <div className={styles.linkBox}>
              <span className={styles.linkUrl} title={url}>{url}</span>
              <button
                type="button"
                className={`${styles.copyButton} ${copied ? styles.copyButtonCopied : ''}`}
                onClick={handleCopy}
                aria-label="Copy share link"
              >
                {copied ? 'Copied' : 'Copy'}
              </button>
            </div>

            <button
              type="button"
              className={styles.revokeButton}
              onClick={onRevoke}
              disabled={revoking}
            >
              {revoking ? 'Stopping…' : 'Stop sharing'}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ShareItemModal;
